<unity-page-container contentHeader="Agreement Users" [contentHeaderSecondary]="$contentHeaderSecondary()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>
  <ng-container actions>
    @for (action of $actions(); track action.actionName) {
      <unity-action-shared [action]="action" />
    }
  </ng-container>
  <unity-grid-agreement-user-shared *unityAuthorize="'Agreement:View'" [agreementId]="$agreementId()" />
</unity-page-container>
